module.exports = __webpack_public_path__ + "media/images/vp/parallax.new.02-6d3ecaa997687888f11dbe07d1338b2e.svg";